/* global gsap ScrollTrigger Power2 */

/* 
based on https://codepen.io/shshaw/pen/vYKBPbv/9e810322d70c306de2d18237d0cb2d78?editors=0010

The video encoding settings are important here to enable frame-by-frame scrubbing. 
	-	distance between keyframes or GOP = 1

GSAP docs:
https://greensock.com/docs/v3/GSAP/Timeline
https://greensock.com/docs/v3/Plugins/ScrollTrigger
*/

// Note: vs- prefix stands for video-scroller

gsap.registerPlugin(ScrollTrigger);
window.videoScroll = {};
let __vs = window.videoScroll;

__vs.animationSets = {
	// A-HomePage
	'A': {
		'mov': 'https://player.vimeo.com/progressive_redirect/download/820705037/rendition/source/a-homepage%20%28Original%29.mov?loc=external&signature=74063ae12440eb2d5c96a5a0a8e3039936d1ab0ab8f2cb12322d39fb10975c44',
		'webm': 'https://player.vimeo.com/progressive_redirect/download/820705122/rendition/source/a-homepage%20%28Original%29.webm?loc=external&signature=4b44b703c262e6cdeaebe8c1ff9a1949151c0e157b415be3a7fc318106806fab',
	},

	// B-TheatrePractitioner
	'B': {
		'mov': 'https://player.vimeo.com/progressive_redirect/download/820573091/rendition/source/b-theatre_practitioner%20%28Original%29.mov?loc=external&signature=e696495a182aa1f4c768db6b4a5648223281e338653ac32fb9e8ca78a00b85b6',
		'webm': 'https://player.vimeo.com/progressive_redirect/download/820573964/rendition/source/b-theatre_practitioner%20%28Original%29.webm?loc=external&signature=75099f83a7c74480b1586b6b3c307609acb720174b39f50157f862c323c940a6',
	},

	// C-Physio
	'C': {
		'mov': 'https://player.vimeo.com/progressive_redirect/download/820575262/rendition/source/c-physio%20%28Original%29.mov?loc=external&signature=93c73e8264bd03cfbd582c9d2b5760193d3d7daf8341a7751da8a029ba633f09',
		'webm': 'https://player.vimeo.com/progressive_redirect/download/820576828/rendition/source/c-physio%20%28Original%29.webm?loc=external&signature=717e0c96c4f719e2694c55295ba4a0e4c67fd2258a9b2f2a94ac562f452bea92',
	},

	// D-Pharmacist
	'D': {
		'mov': 'https://player.vimeo.com/progressive_redirect/download/820578092/rendition/source/d-pharmacist%20%28Original%29.mov?loc=external&signature=df62dda6c08402ee2e877426975dcc2ca4fa43ce0161728b55aec6979340a693',
		'webm': 'https://player.vimeo.com/progressive_redirect/download/820579558/rendition/source/d-pharmacist%20%28Original%29.webm?loc=external&signature=6b40c9412576483f6309e4a085ba521b50893df314c330af222b91e56f4a998d',
	},

	// E-Radiographer
	'E': {
		'mov': 'https://player.vimeo.com/progressive_redirect/download/820581317/rendition/source/e-radiographer%20%28Original%29.mov?loc=external&signature=d5f2ca3fc2e9bc21c4b987287f8cd4db251e33bbf3bd6599b3e604dd10e71df3',
		'webm': 'https://player.vimeo.com/progressive_redirect/download/820582538/rendition/source/e-radiographer%20%28Original%29.webm?loc=external&signature=34936d39f6eaa3c525c84c75205addf2d14480a22dcdc8b19097af0c6bad395c',
	},

	// F-Management
	'F': {
		'mov': 'https://player.vimeo.com/progressive_redirect/download/820583886/rendition/source/f-management%20%28Original%29.mov?loc=external&signature=bbff7d12b2b612f2d23ae1adbbf7003c571a3cd0c1884f379ee9ef455c65e702',
		'webm': 'https://player.vimeo.com/progressive_redirect/download/820585198/rendition/source/f-management%20%28Original%29.webm?loc=external&signature=74c398c37ee1e1b1f10309a14ebfa13913bfbf302180e7e55e9fcc0eecab2c6a',
	},

	// H-HouseKeeper
	'H': {
		'mov': 'https://player.vimeo.com/progressive_redirect/download/820589006/rendition/source/h-housekeeper%20%28Original%29.mov?loc=external&signature=8eb776ecc0b05b2567d665fada6afeb7644fb31f0cef9f4534ec0d0f03ed6ec4',
		'webm': 'https://player.vimeo.com/progressive_redirect/download/820590118/rendition/source/h-housekeeper%20%28Original%29.webm?loc=external&signature=72a2a7e75c6216a17600d129234392ef01e51b16f8c2b95a4c064a25783d2cc1',
	},

	// K-Administration
	'K': {
		'mov': 'https://player.vimeo.com/progressive_redirect/download/820593800/rendition/source/k-administration%20%28Original%29.mov?loc=external&signature=8c71116588eefe15c703c00c5f62b3d800e9b3cb105fe74cdaa90a8e9ac027c0',
		'webm': 'https://player.vimeo.com/progressive_redirect/download/820595459/rendition/source/k-administration%20%28Original%29.webm?loc=external&signature=4428ae55a5c2a03ec251d3f906c8a1f2c8fc71891421b62d97b4499dbcafca13',
	}

};

__vs.once = function (el, event, fn, opts) {
	if (!el) {
		return;
	}

	var onceFn = function () {
		el.removeEventListener(event, onceFn);
		fn.apply(this, arguments);
	};
	el.addEventListener(event, onceFn, opts);
	return onceFn;
};

__vs.init = function () {
	if (__vs.scrollWrapper === null) {
		return;
	}

	document.addEventListener('DOMContentLoaded', __vs.refreshScrollerMetrics);
	window.addEventListener('load', __vs.refreshScrollerMetrics);

	__vs.scrollWrapper.innerHTML = __vs.generateMarkup(__vs.scrollWrapper);

	__vs.video = document.querySelector('video.vs-background');
	__vs.video.pause(); // autoplay attribute helps load the video, so pause it

	__vs.defineVideoMetrics();

	__vs.defineAnimatedElements();

	// Useful video loading events
	// canplaythrough: when enough video data has loaded, set up the timeline, needs user interaction to allow interactivity
	// loadedmetadata: when the video info is loaded - lets necessary video interactivity start without user interaction
	__vs.once(__vs.video, 'loadedmetadata', () => {
		// __vs.assembleIntroTimeline();
		__vs.stInstance = __vs.setupIntroVideo();
		document.querySelector('.video-scroller-wrap').classList.add('active');
		// __vs.refreshScrollerMetrics();
	});
};

__vs.getRandomAnimationSet = function () {
	// get all the keys in __vs.animationSets
	const avatarsIds = Object.keys(__vs.animationSets);

	// get a random element from that array https://stackoverflow.com/a/5915122
	const avatarId = avatarsIds[Math.floor(Math.random() * avatarsIds.length)];
	// console.log(`Avatar: ${avatarId}`);

	return __vs.animationSets[avatarId];
};

__vs.generateMarkup = function () {
	const randomAvatarSet = __vs.getRandomAnimationSet();
	let urlQuicktime = randomAvatarSet.mov;
	let urlWebm = randomAvatarSet.webm;

	let markup = `
	<div class="vs-loader">
		<span class="circle-loader-1"></span>
	</div>
	<div class="vs-animation">
		<video autoplay="true" playsinline="true" webkit-playsinline="true" preload="auto" muted="muted" class="vs-background" tab-index="0">
			<source src="${urlQuicktime}" type="video/quicktime"></source>
			<source src="${urlWebm}" type="video/webm"></source>
		</video>
		<h2 id="vs-text-01" class="vs-text vs-text-01">
			<span id="vs-text-01-A" class="vs-text-word">Ready</span>
			<span id="vs-text-01-B" class="vs-text-word">to</span>
			<span id="vs-text-01-C" class="vs-text-word">resist</span>
			<span id="vs-text-01-D" class="vs-text-word">the</span>
			<span id="vs-text-01-E" class="vs-text-word">ordinary?</span>
		</h2>
		<p id="vs-text-02" class="vs-text vs-text-02">
			<span id="vs-text-02-A" class="vs-text-word">Healthcare careers<br></span>
			<span id="vs-text-02-B" class="vs-text-word">that are anything but the usual.</span>
		</p>
	</div>
	`;

	return markup;
};

__vs.defineVideoMetrics = function () {
	__vs.videoDuration = 5; // video duration in seconds
	__vs.scrollSpeed = 100; // Higher is faster/more frames advanced per scroll
	__vs.videoFrames = 150; // actual number of frames in video

	__vs.scrollLength = (__vs.videoFrames / __vs.scrollSpeed) * 1000;
	__vs.oneSecondOfScroll = 1 / __vs.videoDuration;
	__vs.oneHalfSecondOfScroll = __vs.oneSecondOfScroll / 2;
	__vs.oneQuarterSecondOfScroll = __vs.oneSecondOfScroll / 4;
	__vs.oneFifthSecondOfScroll = __vs.oneSecondOfScroll / 5;
	__vs.oneTenthSecondOfScroll = __vs.oneSecondOfScroll / 10;

	__vs.introIdleStart = 4.5; // idle start frame time
	__vs.introIdleEnd = __vs.videoDuration; // idle end frame time
	__vs.introExitFrame = 3.5; // frame time when avatar intro video disappears
	__vs.introPreview = 0.1; // number of seconds of video to play before scrollTrigger takes over
};

__vs.defineAnimatedElements = function () {
	// Text elements
	__vs.text01 = document.querySelector('#vs-text-01');
	__vs.text01A = document.querySelector('#vs-text-01-A');
	__vs.text01B = document.querySelector('#vs-text-01-B');
	__vs.text01C = document.querySelector('#vs-text-01-C');
	__vs.text01D = document.querySelector('#vs-text-01-D');
	__vs.text01E = document.querySelector('#vs-text-01-E');

	__vs.text02 = document.querySelector('#vs-text-02');
	__vs.text02A = document.querySelector('#vs-text-02-A');
	__vs.text02B = document.querySelector('#vs-text-02-B');

	// gsap text animation timelines
	__vs.tlText01 = __vs.textAnim01();
	__vs.tlText02 = __vs.textAnim02();
};

__vs.textAnim01 = function () {

	const localDuration = 0.5;
	const localDelay = 0.1;

	// CREATE FIRST TEXT ANIMATION
	// "Ready to resist the ordinary?"
	let tl = gsap
		.timeline()
		// text01 staggered entrance
		.fromTo(
			__vs.text01A,
			{
				autoAlpha: 0,
				top: '60vh'
			},
			{
				autoAlpha: 1,
				top: '0vh',
				ease: 'power4.in',
				duration: localDuration
			}
		)
		.fromTo(
			__vs.text01B,
			{
				autoAlpha: 0,
				top: '60vh'
			},
			{
				autoAlpha: 1,
				top: '0vh',
				ease: 'power4.in',
				duration: localDuration,
				delay: localDelay
			},
			'<'
		)
		.fromTo(
			__vs.text01C,
			{
				autoAlpha: 0,
				top: '60vh'
			},
			{
				autoAlpha: 1,
				top: '0vh',
				ease: 'power4.in',
				duration: localDuration,
				delay: localDelay
			},
			'<'
		)
		.fromTo(
			__vs.text01D,
			{
				autoAlpha: 0,
				top: '60vh'
			},
			{
				autoAlpha: 1,
				top: '0vh',
				ease: 'power4.in',
				duration: localDuration,
				delay: localDelay
			},
			'<'
		)
		.fromTo(
			__vs.text01E,
			{
				autoAlpha: 0,
				top: '60vh'
			},
			{
				autoAlpha: 1,
				top: '0vh',
				ease: 'power4.in',
				duration: localDuration,
				delay: localDelay
			},
			'<'
		)
		.fromTo(
			__vs.text01,
			{
				autoAlpha: 1
			},
			{
				autoAlpha: 0,
				duration: localDuration,
				delay: localDuration
			},
			'>'
		);

	return tl;
};

__vs.textAnim02 = function () {
	const localDuration = 0.5;

	// CREATE 2nd TEXT ANIMATION
	// "Healthcare careers
	// that are anything but the usual."
	let tl = gsap
		.timeline()
		// .set(__vs.text02, { autoAlpha: 1 })
		.fromTo(
			__vs.text02A,
			{
				autoAlpha: 0,
				left: '-50vw'
			},
			{
				autoAlpha: 1,
				left: '0vw',
				ease: 'power4.in',
				duration: localDuration
			},
			'>'
		)
		.fromTo(
			__vs.text02B,
			{
				autoAlpha: 0,
				right: '-50vw'
			},
			{
				autoAlpha: 1,
				right: '0vw',
				ease: 'power4.in',
				duration: localDuration
			},
			'>'
		);


	return tl;
};

__vs.setupIntroVideo = function () {
	// one-off fade-in
	__vs.video.currentTime = __vs.introIdleStart;
	gsap.fromTo(
		__vs.video,
		{ autoAlpha: 0},
		{ autoAlpha: 1, duration: 0.5, delay: 1 }
	);

	// ensure that text animations are hidden from start
	gsap.set([
		__vs.text01A,
		__vs.text01B,
		__vs.text01C,
		__vs.text01D,
		__vs.text01E,
		__vs.text02A,
		__vs.text02B
	], { autoAlpha: 0 });
	
	let tl = gsap.timeline({
		defaults: { duration: 1 },
		scrollTrigger: {
			trigger: __vs.scrollWrapper,
			start: 'top 20%',
			end: 'bottom 50%',
			fastScrollEnd: true,
			once: true,
			// on leave, fade out the 'scroll down' icon
			onLeave: () => gsap.to('.circle_top_to_bottom', {autoAlpha: 0, duration: 1})
		}
	})
		// fade initial scene out
		.to(
			__vs.video,
			{
				autoAlpha: 0,
				duration: 0.5
			}
		)
		// set video to start frame, then play it
		.set(
			__vs.video,
			{autoAlpha: 1, currentTime: 0, onComplete: () => __vs.video.play()}
		)
		// add text animation timelines
		.add(__vs.tlText01, '1.8')
		.add(__vs.tlText02, '>1')
		;
	
	return tl;
};

__vs.assembleIntroTimeline = function () {
	__vs.video.currentTime = __vs.introIdleStart;

	// one-off fade-in
	gsap.fromTo(
		__vs.video,
		{ autoAlpha: 0},
		{ autoAlpha: 1, duration: 0.5, delay: 1 }
	);

	__vs.tlIntro = gsap.timeline({
		defaults: { duration: 1 },
		scrollTrigger: {
			trigger: __vs.scrollWrapper,
			start: 'top top',
			end: `+=${__vs.scrollLength}`,
			scrub: 0.3,
			pin: true,
			fastScrollEnd: true,
			onLeave: __vs.disableScroll,
			once: true,
			preventOverlaps: true,
			invalidateOnRefresh: true
		}
	})
		.to(
			__vs.video,
			{
				currentTime: __vs.introIdleEnd,
				autoAlpha: 0,
				duration: 0.1
			}
		)
		.add(gsap.to(
			__vs.video,
			{autoAlpha: 1, duration: 0, currentTime: 0}
		))
		.fromTo(
			__vs.video,
			{
				currentTime: 0
			},
			{
				currentTime: __vs.videoDuration
			}
		)
		.add(__vs.tlText01, __vs.oneTenthSecondOfScroll)
		.add(__vs.tlText02, '>-={__vs.oneSecondOfScroll}')

	;

};

__vs.disableScroll = function () {
	// console.log('__vs.disableScroll');
	const duration = 0.5;
	const ease = Power2. easeInOut;
	const wrapperHeight = __vs.scrollWrapper.offsetHeight;

	gsap.to(__vs.scrollWrapper, { transform: 'translate(0px, 0px)', duration: duration, ease: ease });
	gsap.to(__vs.scrollWrapper.parentElement, { 'padding-bottom': '0px', height: wrapperHeight, duration: duration, ease: ease });

	gsap.delayedCall(duration, () => {
		if (__vs.tlScroll) {
			// set to end state even if scrolled past too fast
			__vs.tlScroll.progress(0, true).play();
		}

		// now recalculate all start and end positions of all other ScrollTriggers on the page
		__vs.refreshScrollerMetrics();
	});
};

__vs.refreshScrollerMetrics = function () {
	let scrollers = ScrollTrigger.getAll();
	for (const scroller of scrollers) {
		scroller.refresh();
	}
};

__vs.main = function () {
	__vs.scrollWrapper = document.getElementById('video-scroller');

	if (!__vs.scrollWrapper) {
		return;
	} else {
		__vs.init();
	}
};

__vs.main();
